import FaveBizAPI from 'integrations/FaveBizAPI';
import { GenericSuccessType } from '../types/GenericSuccessType';

export const createFeedPost = (param: FormData): Promise<GenericSuccessType> =>
  FaveBizAPI.post(`/v1/feed`, param);
